export class MobilePanel extends HTMLElement {
  mobileNavigation;
  openSelector;
  isOpen = false;
  locked = false;

  constructor() {
    super();
    this.isOpen = false;
    this.locked = false;
    this.mobileNavigation = document.querySelector('mobile-navigation');

    document.documentElement.append(this);

    this.addEventListener('transitionstart', (ev) => (this.locked = true));
    this.addEventListener('transitionend', (ev) => (this.locked = false));

    this.addEventListener('custom:escape', (ev) => {
      this.close();
    });
  }

  open() {
    if (this.locked) return;
    this.classList.remove('hidden');
    const currentScrollPosition = document.documentElement.scrollTop;
    if (currentScrollPosition > 0) {
      document.querySelector('shallow-clone')?.pauseScroll();
      window.cacheHeight(currentScrollPosition);
    }
    requestAnimationFrame(() => {
      this.classList.remove('translate-x-full');
    });
    waitForTransitionEnd(this).then(() => {
      trapFocus(this);
      this.mobileNavigation.classList.add('hidden');
    });
  }

  close() {
    if (this.locked) return;
    this.mobileNavigation.classList.remove('hidden');
    this.classList.add('translate-x-full');
    releaseFocus(this);
    document.querySelector(this.openSelector).focus();
    requestAnimationFrame(() => {
      window.restoreHeight();
    });
    waitForTransitionEnd(this).then(() => this.classList.add('hidden'));
  }
}

class CountryPanel extends MobilePanel {
  constructor() {
    super();
    this.openSelector = '[open-country-panel]';

    document.querySelector(this.openSelector).addEventListener('click', (ev) => {
      this.open();
    });

    this.querySelector('[country-choice]')?.addEventListener('click', (ev) => {
      if (ev.target.nodeName === 'BUTTON' && ev.target.dataset.value) {
        ev.preventDefault();
        this.triggerForm(ev.target.dataset.value, 'country_code');
      }
    });

    this.querySelector('[top-country-choice]')?.addEventListener('click', (ev) => {
      if (ev.target.nodeName === 'BUTTON' && ev.target.dataset.value) {
        ev.preventDefault();
        this.triggerForm(ev.target.dataset.value, 'country_code');
      }
    });

    this.querySelector('[close-country-panel]').addEventListener('click', (ev) => {
      this.close();
    });

    const countrySearchInputMobile = this.querySelector('#country-search-mobile');
    if (countrySearchInputMobile) {
      countrySearchInputMobile.addEventListener('input', this.filterCountries.bind(this));
    }
  }

  triggerForm(value, name) {
    const controlInput = this.querySelector(`input[name="${name}"]`);
    controlInput.value = value;
    this.querySelector('form').submit();
  }

  filterCountries(event) {
    const normalize = (str) =>
      str
        .toLowerCase()
        .replace(/[^\p{L}\s]/gu, '')
        .replace(/\s+/g, ' ')
        .trim();
    const searchQuery = normalize(event.target.value);

    const countryItems = this.querySelectorAll('ul[country-choice] li');
    const noResultsMessage = this.querySelector('.country-choice-no-results');
    const topCountryChoice = this.querySelector('[top-country-choice]');

    let hasResults = false;

    if (topCountryChoice) {
      if (searchQuery.length > 0) {
        topCountryChoice.classList.add('hidden');
      } else {
        topCountryChoice.classList.remove('hidden');
      }
    }

    countryItems.forEach((item) => {
      const countryButton = item.querySelector('button');
      if (countryButton) {
        const countryName = normalize(countryButton.textContent);
        if (countryName.includes(searchQuery)) {
          item.classList.remove('hidden');
          hasResults = true;
        } else {
          item.classList.add('hidden');
        }
      }
    });

    if (noResultsMessage) {
      if (hasResults) {
        noResultsMessage.classList.add('hidden');
      } else {
        noResultsMessage.classList.remove('hidden');
      }
    }
  }
}

customElements.define('country-panel', CountryPanel);

class LanguagePanel extends MobilePanel {
  constructor() {
    super();
    this.openSelector = '.open-language-panel';

    document.querySelector(this.openSelector).addEventListener('click', (ev) => {
      this.open();
    });

    this.querySelector('.close-language-panel').addEventListener('click', (ev) => {
      this.close();
    });
  }
}

customElements.define('language-panel', LanguagePanel);
